module.exports = __webpack_public_path__ + "img/container-title.ca6d7e1e.png";